module.exports = __webpack_public_path__ + "docs/assets/fonts/Roboto-Medium-68ea4734cf86bd544650aee05137d7bb.ttf";